import { Progress } from "reactstrap";
import { ProgressBarProps } from "../../Types/CommonElementType";

const ProgressBar: React.FC<ProgressBarProps> = (props) => {
  return <Progress {...props}>{props.children}</Progress>;
};

export default ProgressBar;
